// extracted by mini-css-extract-plugin
module.exports = {"unread":"ListItemChat_unread__2zuUU","read":"ListItemChat_read__-rBFJ","topic":"ListItemChat_topic__LhsXH","time":"ListItemChat_time__2GJHP","note":"ListItemChat_note__1r2Jm"};